// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2v25-","error":"Textarea_error__1OubK","readonly":"Textarea_readonly__2Z9U6","disabled":"Textarea_disabled__1gErb"};